import { AppContainerId } from '../../enum';

const getLoadingSpinnerHtml = () =>
    `<div id="${AppContainerId.OVERLAY_LOADING}" class="fixnet-loading-spinner ws10-is-hidden"></div>`;

export default {
    getLoadingSpinnerHtml,
};
